import { createContext } from 'react';
import { DashboardRootStore } from '../store/dashboard.store';

export const DashboardStoreContext = createContext<DashboardRootStore>(new DashboardRootStore());
